export enum UIWorkflowItemIntegrationOperatorType {
  FlatMap = 'flat-map',
  MergeMap = 'merge-map',
  SwitchMap = 'switch-map',
  ExhaustMap = 'exhaust-map',
  ConcatMap = 'concat-map',
  Map = 'map',
  Tap = 'tap',
}
